<div id="leve-report-modal" class="leave-report-genarate">
    <div class="popoup-hearder">
        <h2 class="m-b-5" mat-dialog-title>Informe de Baja</h2>
    </div>
    <div class="popoup-content">
        <app-template-selector></app-template-selector>
    </div>
    <div class="popoup-footer">
        <button mat-button color="primary" class="keep" (click)="generateReport()"><span
            class="mat-button-wrapper">Aceptar</span></button>
    <button mat-button color="accent" class="cancel" (click)="close()"><span
            class="mat-button-wrapper">Cancelar</span></button>
    </div>
</div>